import { useSelectedCustomerId } from 'src/store/customer/useSelectedCustomerId';

import { useMaintainNotifications } from './services/useMaintainNotifications';

// A reviewer gets the account's notifications, but has no customer data to keep up to date.
export const ReviewerDataUpdater = () => {
  useMaintainNotifications({ customerId: useSelectedCustomerId() });

  return null;
};
